const style = (theme) => {
  const output = {
    root: {
      '& > div:not(:last-child)': {
        marginBottom: 30,
      },
    },
    pretitle: {
      fontSize: 16,
      letterSpacing: 1,
      textTransform: 'uppercase',
      opacity: 0,
    },
    backLink: {
      fontSize: 16,
      letterSpacing: 1,
      textTransform: 'uppercase',
      opacity: 0,
      '& span': {
        fontWeight: 'bold',
        marginRight: 10,
      },
      '& button': {
        color: theme.colors[1],
        textTransform: 'uppercase',
        cursor: 'pointer',
      },
    },
    cream: {
      color: '#f3f0e9',
    },
    title: {
      lineHeight: 1.2,
      overflow: 'hidden',
      paddingLeft: 12,
    },
    link: {
      marginTop: 50,
      opacity: 0,
    },
  }

  output[theme.mediaInverse.sm] = {
  }

  return output
}

export default style
